// Override Settings
var bcSfSearchSettings = {
    search: {
      enableFuzzy: true,
      fuzzy: 1

        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};